const IMAGE_MIME_TYPES = new Set([
    "image/png",
    "image/jpeg",
    "image/gif",
    "image/webp",
    "image/svg+xml",
    "image/bmp",
    "image/tiff",
]);
export const isImageMimeType = (type) => {
    return IMAGE_MIME_TYPES.has(type);
};
//# sourceMappingURL=mime.js.map